import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginPage.vue"),
  },
  {
    path: "/escuelas",
    name: "escuelas",
    component: () => import("../views/EscuelasView.vue"),
  },
  {
    path: "/busqueda-avanzada",
    name: "busqueda-avanzada",
    component: () => import("../views/busquedaAvanzada.vue"),
  },
  {
    path: "/liquidacion-horas-extras/:escuelaId",
    name: "liquidacion-horas-extras",
    component: () => import("../views/LiquidacionHorasExtrasView.vue"),
    props: true,
  },
  {
    path: "/configuracion",
    name: "configuracion",
    component: () => import("../views/ConfiguracionView.vue"),
  },
 
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
